"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMon305LogExposure = exports.mon305VariantSelector = exports.useMon138LogExposure = exports.mon138HasShiftedCalcSelector = exports.mon138HasAnchorSelector = exports.useMon386LogExposure = exports.mon386VariantSelector = exports.isExperimentTreatmentRequestLoadingSelector = exports.experimentParameterSelector = exports.experimentTreatmentSelector = void 0;

var _laboratoryLib = require("laboratory-lib");

var _ConfigSelectors = require("./ConfigSelectors");

var _MarketingContactsSelectors = require("./MarketingContactsSelectors");

var _reactRedux = require("react-redux");

var _react = require("react");

var _laboratoryClient = require("laboratory-client");

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

var experimentTreatmentSelector = function experimentTreatmentSelector(_ref, treatmentKey) {
  var treatments = _ref.experimentTreatments.treatments;
  if (!treatments) return null;
  return (0, _laboratoryLib.getTreatment)(treatments, treatmentKey);
};

exports.experimentTreatmentSelector = experimentTreatmentSelector;

var experimentParameterSelector = function experimentParameterSelector(state, treatmentKey, parameterKey) {
  var treatment = experimentTreatmentSelector(state, treatmentKey);
  return (0, _laboratoryLib.getParameter)(treatment, parameterKey);
};

exports.experimentParameterSelector = experimentParameterSelector;

var isExperimentTreatmentRequestLoadingSelector = function isExperimentTreatmentRequestLoadingSelector(_ref2) {
  var isLoading = _ref2.experimentTreatments.isLoading;
  return isLoading;
};

exports.isExperimentTreatmentRequestLoadingSelector = isExperimentTreatmentRequestLoadingSelector;

var mon386VariantSelector = function mon386VariantSelector(state) {
  if ((0, _MarketingContactsSelectors.isInMCBetaSelector)(state)) return 'control';
  var publicParam = experimentParameterSelector(state, 'cbx-386p', 'subtext');
  var authedParam = experimentParameterSelector(state, 'cbx-386', 'subtext');
  var paramToUse = (0, _ConfigSelectors.isAppAuthSelector)(state) ? authedParam : publicParam;
  return paramToUse.value || 'control';
};

exports.mon386VariantSelector = mon386VariantSelector;

var useMon386LogExposure = function useMon386LogExposure() {
  var mon386TreatmentKey = (0, _reactRedux.useSelector)(_ConfigSelectors.isAppAuthSelector) ? 'cbx-386' : 'cbx-386p';
  var treatment = (0, _reactRedux.useSelector)(function (state) {
    return experimentTreatmentSelector(state, mon386TreatmentKey);
  });
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  (0, _react.useEffect)(function () {
    if (!isInMCBeta) {
      (0, _laboratoryClient.logExposure)(treatment);
    }
  }, [isInMCBeta]);
};

exports.useMon386LogExposure = useMon386LogExposure;

var mon138VariantSelector = function mon138VariantSelector(state) {
  if ((0, _MarketingContactsSelectors.isInMCBetaSelector)(state)) return _ExperimentConstants.MON138_PARAMETER_OPTIONS.CONTROL;
  var publicParam = experimentParameterSelector(state, _ExperimentConstants.MON138_PUBLIC_TREATMENT_KEY, _ExperimentConstants.MON138_PARAMETER_KEY);
  var authedParam = experimentParameterSelector(state, _ExperimentConstants.MON138_IN_APP_TREATMENT_KEY, _ExperimentConstants.MON138_PARAMETER_KEY);
  return (0, _ConfigSelectors.isAppAuthSelector)(state) ? authedParam.value : publicParam.value;
};

var mon138HasAnchorSelector = function mon138HasAnchorSelector(state) {
  return mon138VariantSelector(state) === _ExperimentConstants.MON138_PARAMETER_OPTIONS.ANCHOR;
};

exports.mon138HasAnchorSelector = mon138HasAnchorSelector;

var mon138HasShiftedCalcSelector = function mon138HasShiftedCalcSelector(state) {
  return mon138VariantSelector(state) === _ExperimentConstants.MON138_PARAMETER_OPTIONS.SHIFTED;
};

exports.mon138HasShiftedCalcSelector = mon138HasShiftedCalcSelector;

var useMon138LogExposure = function useMon138LogExposure() {
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var mon138TreatmentKey = (0, _reactRedux.useSelector)(_ConfigSelectors.isAppAuthSelector) ? _ExperimentConstants.MON138_IN_APP_TREATMENT_KEY : _ExperimentConstants.MON138_PUBLIC_TREATMENT_KEY;
  var treatment = (0, _reactRedux.useSelector)(function (state) {
    return experimentTreatmentSelector(state, mon138TreatmentKey);
  });
  (0, _react.useEffect)(function () {
    if (!isInMCBeta) (0, _laboratoryClient.logExposure)(treatment);
  }, [isInMCBeta]);
};

exports.useMon138LogExposure = useMon138LogExposure;

var mon305VariantSelector = function mon305VariantSelector(state) {
  var authedParam = experimentParameterSelector(state, _ExperimentConstants.MON305_IN_APP_TREATMENT_KEY, _ExperimentConstants.MON305_PARAMETER_KEY);
  var paramToUse = (0, _ConfigSelectors.isAppAuthSelector)(state) ? authedParam : {};
  return paramToUse.value === _ExperimentConstants.MON305_PARAMETER_OPTIONS.VARIANT;
};

exports.mon305VariantSelector = mon305VariantSelector;

var useMon305LogExposure = function useMon305LogExposure() {
  var isInApp = (0, _reactRedux.useSelector)(_ConfigSelectors.isAppAuthSelector);
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var mon305TreatmentKey = isInApp ? _ExperimentConstants.MON305_IN_APP_TREATMENT_KEY : null;
  var treatment = (0, _reactRedux.useSelector)(function (state) {
    return experimentTreatmentSelector(state, mon305TreatmentKey);
  });
  (0, _react.useEffect)(function () {
    if (!isInMCBeta && isInApp) {
      (0, _laboratoryClient.logExposure)(treatment);
    }
  }, [isInMCBeta]);
};

exports.useMon305LogExposure = useMon305LogExposure;